module.exports = __webpack_public_path__ + "static/media/f.c56c0a11.png";